import(/* webpackMode: "eager" */ "/vercel/path0/components/marketing/MarketingArticle.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/marketing/MarketingChrome.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
